// extracted by mini-css-extract-plugin
module.exports = {"checkboxWrap":"SisCheckbox_checkboxWrap__1k3Mo","checkbox":"SisCheckbox_checkbox__1b0pw","on":"SisCheckbox_on__2Nv2d","off":"SisCheckbox_off__7zBSz"};